<template>
  <div>
    <v-dialog v-model="dialog" width="1870">
      <validation-observer v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit(save)">
          <v-card height="90vh" style="overflow: hidden">
            <v-card-text class="pt-4" style="height: 80vh; overflow: hidden">
              <div class="d-flex align-center mb-4 justify-space-between">
                <div class="d-flex align-center">
                  <h2 class="order_dialog_number_application">
                    {{
                      isCreatingContract
                        ? $t("createContract")
                        : $t("addToContract")
                    }}
                  </h2>
                </div>
                <div>
                  <v-btn
                    text
                    fab
                    small
                    color="#01617F"
                    class="ml-5"
                    @click="dialog = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </div>

              <viewer-window style="height: 100%">
                <template #left>
                  <v-card
                    :loading="loading"
                    class="elevation-0"
                    style="padding: 10px"
                    :disabled="isDisabledForm || loading"
                  >
                    <v-container
                      class="pa-0 user_modal_form ozl_table_modal_from"
                    >
                      <v-row v-if="showHeader">
                        <v-col cols="12" md="6">
                          <div class="row no-gutters py-1">
                            <div
                              class="col-sm-5 col-12 medium_15_01456A pt-sm-2"
                            >
                              {{ $t("contractNumber") }}*
                            </div>
                            <div class="col-sm-6 col-12">
                              <custom-input-text
                                v-if="isCreatingContract"
                                v-model="formData.code"
                                :name="$t('nContract')"
                                :placeholder="$t('contractNumber')"
                                class="user_input no-margin"
                                clearable
                                rules="required"
                                data-test="ozlOrders-orderDialog-input-contractNumber"
                              >
                              </custom-input-text>
                              <vue-select
                                v-else
                                infinite
                                v-model="formData.id"
                                :get-item-promise="getContracts"
                                :items="contracts"
                                :name="$t('nContract')"
                                class="product-select-in-modal"
                                item-text="code"
                                rules="required"
                                @item-resolved="setContract"
                                @next-page-resolved="
                                  (data) => setContract([...contracts, ...data])
                                "
                                @input="selectHandlerContract"
                                data-test="ozlOrders-orderDialog-select-contracts"
                              ></vue-select>
                            </div>
                          </div>
                          <div class="row no-gutters py-1">
                            <div class="col-sm-5 medium_15_01456A pt-sm-2 pt-3">
                              {{ $t("supplier") }}*
                            </div>
                            <div class="col-sm-6 col-12 d-flex align-center">
                              <template>
                                <vue-select
                                  ref="supplierSelectRef"
                                  infinite
                                  v-model="formData.supplierId"
                                  :disabled="true"
                                  :items="contracts"
                                  :name="$t('supplier')"
                                  :placeholder="$t('supplier')"
                                  class="user_input product-select-in-modal flex-grow-1"
                                  :item-text="
                                    (val) =>
                                      val.supplier.name ? val.supplier.name : ''
                                  "
                                  :item-value="(val) => val.supplier.id || null"
                                  data-test="ozlOrders-orderDialog-select-supplier"
                                ></vue-select>
                              </template>

                              <div
                                v-if="isCreatingContract"
                                class="modal_plus_icon_ft mt-3"
                                @click="supplierDialog = true"
                              >
                                <v-tooltip
                                  color="#fff"
                                  left
                                  nudge-right="10"
                                  nudge-top="35"
                                >
                                  <template #activator="{ on, attrs }">
                                    <span
                                      v-bind="attrs"
                                      v-on="on"
                                      class="modal_plus_icon ml-3 primary--text"
                                      style="font-size: 35px"
                                      >+</span
                                    >
                                  </template>
                                  <span>{{ $t("createSupplier") }}</span>
                                </v-tooltip>
                              </div>
                            </div>
                          </div>
                          <div class="row no-gutters py-1">
                            <div
                              class="col-sm-5 col-12 pt-3 pt-sm-2 medium_15_01456A"
                            >
                              {{ $t("typeDelivery") }}*
                            </div>
                            <custom-select
                              v-model="formData.supplyType"
                              :items="contracts"
                              :disabled="true"
                              :item-text="
                                (val) =>
                                  val.supplyType
                                    ? val.supplyType[`name_${$i18n.locale}`]
                                    : ''
                              "
                              :item-value="
                                (val) =>
                                  val.supplyType ? val.supplyType.id : null
                              "
                              :name="$t('typeDelivery')"
                              :placeholder="$t('typeDelivery')"
                              add-class="user_input"
                              class="col-sm-6 col-12 user_input no-margin"
                              data-test="ozlOrders-orderDialog-select-typeDelivery"
                            ></custom-select>
                          </div>
                        </v-col>
                        <v-col cols="12" md="6">
                          <div class="d-flex py-1 no-gutters flex-wrap">
                            <div
                              class="col-sm-6 col-12 pt-sm-2 pt-3 medium_15_01456A flex-shrink-0"
                            >
                              {{ $t("contractDate") }}*
                            </div>
                            <custom-date-picker
                              v-model="formData.conclusionDate"
                              :disabled="!isCreatingContract"
                              :max="formData.guessReceiveDate || new Date()"
                              :name="$t('contractDate')"
                              class="user_input col-sm-6 col-12 no-margin"
                              icon="mdi-calendar-month small"
                              rules="required"
                              data-test="ozlOrders-orderDialog-datePicker-contractDate"
                            ></custom-date-picker>
                          </div>
                          <div class="d-flex no-gutters flex-wrap py-1">
                            <div
                              class="col-sm-6 col-12 pt-sm-2 pt-3 medium_15_01456A"
                            >
                              {{ $t("estimatedDeliveryDate") }}*
                            </div>
                            <custom-date-picker
                              v-model="formData.guessReceiveDate"
                              :name="$t('estimatedDeliveryDate')"
                              class="user_input col-sm-6 col-12 no-margin"
                              icon="mdi-calendar-month small"
                              rules="required"
                              data-test="ozlOrders-orderDialog-datePicker-estimatedDeliveryDate"
                            ></custom-date-picker>
                          </div>
                          <div class="d-flex no-gutters flex-wrap py-1">
                            <div
                              class="col-sm-6 col-12 pt-sm-2 pt-3 medium_15_01456A"
                            >
                              <!--                              {{ $t("contractInitiator") }}*-->
                            </div>
                            <!--                            <div class="col-sm-6 col-12">-->
                            <!--                              <vue-select-->
                            <!--                                infinite-->
                            <!--                                multiple-->
                            <!--                                :name="$t('contractInitiator')"-->
                            <!--                                @next-page-resolved="-->
                            <!--                                  (data) =>-->
                            <!--                                    setInitiator([...contracts, ...data])-->
                            <!--                                "-->
                            <!--                                v-model="formData.userIds"-->
                            <!--                                :item-text="-->
                            <!--                                  (item) => `${item.lastName} ${item.firstName}`-->
                            <!--                                "-->
                            <!--                                :items="contracts"-->
                            <!--                                class="product-select-in-modal"-->
                            <!--                                rules="required"-->
                            <!--                                data-test="ozlOrders-orderDialog-select-initiator"-->
                            <!--                              ></vue-select>-->
                            <!--                            </div>-->
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                    <div>
                      <OzlOrderEditableCountTable
                        :items="[...formData.orderItems, ...selectedContract]"
                      ></OzlOrderEditableCountTable>
                    </div>
                    <div>
                      <files-wrap
                        ref="fileWrapRef"
                        access-delete
                        @showFile="(data) => $refs.pdfViewer.showFile(data)"
                        class="mt-5"
                        :title="$t('documents')"
                        :files.sync="addFiles"
                      />
                    </div>
                  </v-card>
                </template>
                <template #right>
                  <v-card
                    style="border: none"
                    height="100%"
                    class="elevation-0"
                    :disabled="disabledFileView"
                  >
                    <pdf-viewer
                      :contractId="formData.id"
                      :withBtn="false"
                      ref="pdfViewer"
                      @upload-file="onUploadFile"
                      clearable
                    />
                  </v-card>
                </template>
              </viewer-window>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                @click="dialog = false"
                color="error"
                dark
                class="mr-4"
                data-test="ozlOrders-orderDialog-btn-cancel"
                >{{ $t("toCancel") }}
              </v-btn>
              <v-btn
                color="primary"
                class="mr-2"
                :disabled="!formData.id"
                type="submit"
                data-test="ozlOrders-orderDialog-btn-save"
                >{{ $t("approve") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </form>
      </validation-observer>
    </v-dialog>
    <supplier-create-dialog
      v-model="supplierDialog"
      @onSaved="onAddedSupplier"
    ></supplier-create-dialog>
  </div>
</template>

<script>
import ViewerWindow from "@/components/ui/viewer-window/ViewerWindow";
import VueSelect from "@/components/ui/vue-select/VueSelect";
import SupplierCreateDialog from "@/components/ozl/SupplierCreateDialog";
import { deliveryTypes } from "@/utils/constants";
import PdfViewer from "@/components/pdf/PdfViewer";
import FilesWrap from "@/components/ui/files-wrap/FilesWrap";
import OzlOrderEditableCountTable from "@/components/ozl/EditableCountTable.vue";
import { addTimeZone } from "@/utils/pureFunctions.js";
import i18n from "../../plugins/I18n";

export default {
  name: "OzlOrderDialog",
  data() {
    return {
      showHeader: true,
      viewItems: [],
      disabledFileView: false,
      loading: false,
      dialog: false,
      suppliers: [],
      supplierDialog: false,
      selectedContract: [],
      initiators: [],
      contracts: [],
      isCreatingContract: false,
      isDisabledForm: false,
      formData: {
        id: null,
        code: null,
        supplierId: null,
        conclusionDate: null,
        guessReceiveDate: null,
        orderItems: [],
        userIds: [],
        supplyType: null,
        file: null,
      },
      addFiles: [],
      documentFile: null,
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.$refs.pdfViewer.clear();
        this.formData = {
          id: null,
          code: null,
          supplierId: null,
          conclusionDate: null,
          guessReceiveDate: null,
          orderItems: [],
          userIds: [],
          supplyType: null,
          file: null,
        };
        const { form } = this.$refs;
        if (form) {
          form.reset();
        }
        this.addFiles = [];
        this.selectedContract = [];
        this.formData.orderItems = [];
      }
    },
  },
  methods: {
    i18n() {
      return i18n;
    },
    onUploadFile(file) {
      if (!this.addFiles.length) {
        this.addFiles.push(file);
      }
      this.isFileUpdated = true;
      this.isDisabledForm = false;
    },
    setInitiator(initiators) {
      this.initiators = initiators;
    },
    setSupplier(suppliers) {
      this.suppliers = suppliers;
    },
    setContract(contracts) {
      this.contracts = contracts;
    },
    setSupplyType(supplyType) {
      this.formData.supplyType = supplyType;
    },
    onAddedSupplier(data) {
      this.suppliers.push(data);
      this.formData.supplierId = data.id;
    },
    parseOrderItems(item) {
      return {
        ...item,
        canToChange: true,
        isChanging: false,
        changed: false,
        tempCount: item.count,
        oldCount: item.count,
      };
    },
    open({ items, isCreatingContract, showHeader = true }) {
      this.getOrdersOzl(items);
      this.showHeader = showHeader;
      this.isCreatingContract = isCreatingContract;
      this.isDisabledForm = isCreatingContract;
      this.formData = {
        ...this.formData,
        orderItems: items.map(this.parseOrderItems),
      };
      this.dialog = true;
    },
    async getOrdersOzl(items) {
      try {
        await this.$http.get("orders/items-ozl", {
          params: { parentNumbSearch: items[0].contractNumber },
        });
      } catch (err) {
        this.setResponseError({ error: err });
      }
    },
    clearSupplier() {
      this.$refs.supplierSelectRef.reset();
    },
    getContracts() {
      return this.$store.dispatch("getOzlProductList", {
        forOzl: true,
      });
    },
    close() {
      this.dialog = false;
    },
    async save() {
      this.showLoading();
      const {
        supplierId,
        supplyType,
        guessReceiveDate,
        conclusionDate,
        code,
        id,
        orderItems,
        userIds,
      } = this.formData;
      const formData = new FormData();
      formData.append("supplierId", supplierId);
      formData.append("userIds", userIds);
      formData.append("guessReceiveDate", guessReceiveDate);
      formData.append("conclusionDate", conclusionDate);
      formData.append("supplyType", supplyType);
      if (this.addFiles.length && this.addFiles[0].file) {
        formData.append("file", this.addFiles[0].file);
      }
      const orderId = orderItems[0].order_id || null;
      const orderItemsId = orderItems
        .map((item) => {
          return item.id;
        })
        .join(",");
      orderItems.forEach((item, index) => {
        if (item.changed) {
          formData.append(`changedCount[${index}].itemId`, item.id);
          formData.append(`changedCount[${index}].count`, item.count);
        }
      });
      formData.append("orderItems", orderItemsId);
      if (this.isCreatingContract) {
        formData.append("code", code);
      } else {
        formData.append("contractId", id);
        formData.append(
          "contractNumber",
          this.contracts[this.selectedContractIndex].code
        );
        formData.append("orderId", orderId);
      }
      try {
        await this.$http.post("contract/office/attach", formData);
        this.contractDialog = false;
        this.setSuccess({ text: this.$t("successfullySaved") });
        this.$emit("saved");

        this.close();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async selectHandlerContract() {
      const contract = this.contracts[this.selectedContractIndex];
      const { data } = await this.$httpmdconstruction.get(
        `/contract/${this.formData.id}`
      );
      const { supplierName, supplierId } = contract;
      this.clearSupplier();
      this.suppliers = [{ name: supplierName, id: supplierId }];
      if (contract.productResourceLink) {
        const { fileWrapRef } = this.$refs;
        const file = {
          name: contract.productResourceName,
          link: contract.productResourceLink,
        };
        await fileWrapRef.openFile(file);
        this.addFiles = [file];
      }

      this.formData.conclusionDate = addTimeZone(data.begin_date);
      console.log(this.formData.conclusionDate);
      // this.formData.guessReceiveDate = addTimeZone(
      //   addTimeZone(contract.guessReceiveDate)
      // ).toISOStringWithTimeZone();

      this.formData.supplierId = contract.supplier.id;
      this.formData.supplyType = contract.supplyType.id;
    },
  },
  components: {
    OzlOrderEditableCountTable,
    FilesWrap,
    VueSelect,
    SupplierCreateDialog,
    ViewerWindow,
    PdfViewer,
  },
  computed: {
    formTitle() {
      if (this.isUpdate) {
        return this.$t("requestNumberN");
      } else {
        return this.$t("createOrder");
      }
    },
    deliveryTypes: () => deliveryTypes,
    selectedContractIndex() {
      if (!this.formData.id) return -1;
      return this.contracts.findIndex(
        (contract) => contract.id === this.formData.id
      );
    },
  },
};
</script>
